// extracted by mini-css-extract-plugin
module.exports = {"about":"_2WMOtNgZuP3evCZyEdT1Kw"};